export default __webpack_public_path__ + "static/media/Preguntas-orange.e35e4b17.svg";